import { useState } from 'react';
import { useAdminBookings } from '@/api/ads/hooks';
import { ResourceGate } from '@/features/ResourceGate';
import { PageHeader } from '@/components/PageHeader';
import { Card, CardBody } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Select } from '@/components/ui/input';
import { Table, Th, Td, EmptyRow } from '@/components/ui/table';
import { Spinner } from '@/components/ui/spinner';
import { npr, fmtDate, titleCase } from '@/lib/format';

const STATUSES = [
  'draft',
  'pending_payment',
  'pending_review',
  'approved',
  'live',
  'completed',
  'rejected',
  'cancelled',
];

export function AdminBookingsPage() {
  const [status, setStatus] = useState('');
  const { data, isLoading } = useAdminBookings(status ? { status } : {});

  return (
    <ResourceGate slug="ads.bookings">
      <PageHeader
        title="All Bookings"
        description="Every booking across advertisers."
        action={
          <Select value={status} onChange={(e) => setStatus(e.target.value)} className="w-48">
            <option value="">All statuses</option>
            {STATUSES.map((s) => (
              <option key={s} value={s}>
                {titleCase(s)}
              </option>
            ))}
          </Select>
        }
      />
      <Card>
        <CardBody className="p-0">
          {isLoading ? (
            <div className="p-6">
              <Spinner label="Loading bookings…" />
            </div>
          ) : (
            <Table>
              <thead>
                <tr>
                  <Th>Advertiser</Th>
                  <Th>Product</Th>
                  <Th>Dates</Th>
                  <Th>Slots</Th>
                  <Th>Amount</Th>
                  <Th>Status</Th>
                </tr>
              </thead>
              <tbody>
                {(data?.results.length ?? 0) === 0 && <EmptyRow colSpan={6}>No bookings.</EmptyRow>}
                {data?.results.map((b) => (
                  <tr key={b.id}>
                    <Td className="font-medium">{b.advertiser_name ?? '—'}</Td>
                    <Td>{b.product_name}</Td>
                    <Td className="text-muted-foreground">
                      {fmtDate(b.start_date)} → {fmtDate(b.end_date)}
                    </Td>
                    <Td>{b.slots_requested}</Td>
                    <Td>{npr(b.total_amount)}</Td>
                    <Td>
                      <Badge status={b.status}>{b.status_display}</Badge>
                    </Td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </CardBody>
      </Card>
    </ResourceGate>
  );
}
